export default __webpack_public_path__ + "flexible-payment-card@2x.f1f3094.jpg";